import cookie from 'js-cookie';
import { isBrowser } from './util';

export const setCookie = (key, value, domain) => {
  if (isBrowser) {
    const options = {
      expires: 1,
      path: '/',
    };
    if (domain) {
      options.domain = domain;
    }
    cookie.set(key, value, options);
  }
};

export const removeCookie = key => {
  if (isBrowser) {
    cookie.remove(key, {
      // expires: 1,
    });
  }
};

const getCookieFromBrowser = key => {
  return cookie.get(key);
};

const getCookieFromServer = (key, req) => {
  if (!req.headers.cookie) {
    return undefined;
  }
  const rawCookie = req.headers.cookie
    .split(';')
    .find(c => c.trim().startsWith(`${key}=`));
  if (!rawCookie) {
    return undefined;
  }
  return rawCookie.split('=')[1];
};

export const getCookie = (key, req) => {
  return isBrowser ? getCookieFromBrowser(key) : getCookieFromServer(key, req);
};
